import {defineStore} from "pinia";
import {ref} from "vue";

export const useColourThemeStore = defineStore('colourTheme', () => {

    const updating = ref(false)

    // Just the user's themes
    const users_themes = ref([])

    // All themes (including other that are shared)
    const all_themes = ref([])

    const extractOriginalColour = (themes) => {

        for (const item of themes) {
            item.original_colours = [];
            for (const colorArray of item.colour_range) {
                // Extract the 4th hex color (index 3) and add to original_colours
                item.original_colours.push(colorArray[3]);
            }

        }

        return themes;

    }

    const fetchThemes = (usersOnly) => {

        if (typeof usersOnly === 'undefined') {
            usersOnly = false;
        }

        updating.value = true;

        return new Promise((resolve, reject) => {
            axios.get('analysis_theme', { params: { usersOnly: usersOnly } })
                .then((response) => {

                    updating.value = false;
                    if (usersOnly) {
                        users_themes.value = extractOriginalColour(response.data);
                    } else {
                        all_themes.value = extractOriginalColour(response.data);
                    }

                    resolve(response);

                }).catch((error) => {

                    updating.value = false;
                    reject(error)

                });
            });
    }

    const saveTheme = (themeData) => {

        return new Promise((resolve, reject) => {

            let request;

            if (themeData.id) {
                // If "id" exists, it's an update (so patch)
                request = axios.patch('analysis_theme/'+themeData.id, themeData);
            } else {
                request = axios.post('analysis_theme', themeData);
            }

            request
                .then((response) => {
                    updating.value = false;
                    resolve(response);
                })
                .catch((error) => {
                    updating.value = false;
                    reject(error);
                });
        });

    }

    const deleteTheme = (themeId) => {

        return new Promise((resolve, reject) => {
            axios.delete('analysis_theme/' + themeId)
                .then((response) => {

                    updating.value = false
                    resolve(response)

                }).catch((error) => {

                    updating.value = false
                    reject(error)

                })
        })
    }

    const toggleDefault = (action, themeId) => {
        updating.value = true

        return new Promise((resolve, reject) => {
            axios.patch('/analysis_theme/'+themeId+'/default/'+action)
                .then(response => {
                    updating.value = false
                    resolve(response.data)
                })
                .catch(error => {
                    updating.value = false
                    reject(error)
                })
        })
    }

    return {
        updating,
        users_themes,
        all_themes,
        fetchThemes,
        saveTheme,
        deleteTheme,
        toggleDefault
    }

});
